var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var normalizeBenefits = function (benefits, currency) {
    if (!benefits)
        return [];
    return benefits.map(function (b) { return (__assign(__assign({}, b), { value: b.value && /^\d/.test(b.value.trim())
            ? "".concat(currency, " ").concat(b.value.trim())
            : b.value })); });
};
